import type { ProbabilityUser } from '../types/probability-event.types';

export function getDisplayName(user?: ProbabilityUser) {
	const source = user?.full_name || user?.email || 'there';
	const cleanSource = source.split('@')[0].trim();
	return cleanSource.split(' ')[0] || 'there';
}

export const getUserInitial = (user?: ProbabilityUser) => {
	const source = user?.full_name || user?.email || 'A';
	return source.trim().charAt(0).toUpperCase() || 'A';
};
